import React from 'react';
import { TransactionTableInterface } from '../utils';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    generateColumns,
    TaxesTableRowInterface,
    useStyles,
} from './Taxes.utils';
import { useTranslation } from 'react-i18next';
import { taxesEntityTransformer } from '../../../utils/transformers';
import classNames from 'classnames';

const Taxes: React.VFC<TransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: TaxesTableRowInterface[] = data.map(taxesEntityTransformer);

    return (
        <DataGrid<TaxesTableRowInterface>
            data={items}
            dataQa={'taxes-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default Taxes;
